import { createContext, useContext, useEffect, useState } from "react";
import { useTutor } from "./AiTutorContext";
import {
  isEmptyArray,
  isEmptyObject,
  isEmptyOrNull,
  isNotEmptyOrNull,
  isNotUndefinedOrNull,
} from "../utils/common-utils";
import {
  endTask,
  learnApiService,
  saveChatConv,
  callSelfLearn,
  postFactualProgress,
} from "../network/LearnApiService";
import useStateRef from "react-usestateref";
import { usePractice } from "./PracticeContext";
import { startTask } from "../api/task-services";
import { learningModes } from "../utils/LearningPathUtils";
import { useRoot } from "./RootContext";
import { useNavigate } from "@remix-run/react";
const LearnContext = createContext();
export const LearnProvider = ({ children }) => {
  const {
    grade,
    topic,
    subTopic,
    subject,
    isLearn,
    isHome,
    overAllQuestionResult,
    answerCount,
    journeyId,
    taskStepId,

    setIsTaskCompleted,
    setTopic,
    setGrade,
    setSubject,
    setTaskStatus,
    subTopicId,
    subjectId,
    subjectMasterUUid,
    topicId,
    setIsPlayerOpen,
    topicMasterUuid,
    setJourneyId,
    setTaskStepId,
    setLearningStepData,
    learningStepData,
    setExperientialLearningData,
    taskType,
    onNextItemSelected,
    setOnNextItemSelected,
    setIsFactual,
    isFactual,
    isChapterEndAssessment,
    chapterEndAssessmentType,
    callSameSubTopicAgain,
    selectedExperiential,
    isExperientialFromWall,
    setIsExperientialFromWall,
    setTaskAnalytics,
    taskAnalytics,
  } = useTutor();
  const {
    setDisplayedQues,
    displayedQues,
    setCurrentQuestionIndex,
    currentQuesIndex,
    setChatHistory,
    setChatQuery,
    chatId,
  } = usePractice();
  const { topicName, subTopicName, isReviewScreen, setTaskId, taskId } =
    useRoot();
  const [learngStepsData, setLearningStepsData, learningStepsDataRef] =
    useStateRef({});
  const [learnStepId, setLearnStepId, learnStepIdRef] = useStateRef(1);

  // Factual Items
  const [content, setContent, contentRef] = useStateRef(
    learningStepData?.content ? learningStepData?.content : ""
  );
  const [currentIndex, setCurrentIndex, currentIndexRef] = useStateRef(0);
  const [currentContent, setCurrentContent, currentContentRef] = useStateRef(
    {}
  );

  const [showModal, setModalVisibility, showModalRef] = useStateRef(false);
  const [randomIndexsList, setRandomIndexsList, randomIndexsListRef] =
    useStateRef([]);
  const [startTime, setStartTime, startTimeRef] = useStateRef(0);
  const [displayQuestions, setDisplayQuestions, displayQuestionsRef] =
    useStateRef(false);
  const [hideFactual, setHideFactual, hideFactualRef] = useStateRef(false);
  const [endTime, setEndTime, endTimeRef] = useStateRef(0);
  const [questionIndex, setQuestionIndex, questionIndexRef] = useStateRef(0);
  const [correctAnswersCount, setCorrectAnswersCount, correctAnswersCountRef] =
    useStateRef(0);
  const [refreshKey, setRefreshKey, refreshKeyRef] = useStateRef(0);
  const [assessRefreshKey, setAssessRefreshKey, assessRefreshKeyRef] =
    useStateRef(0);
  const [displayExperiential, setDisplayExperiential] = useState(false);
  const [experientialData, setExperientialData] = useState({});
  const [
    questionNotAvailable,
    setQuestionNotAvailable,
    questionNotAvailableRef,
  ] = useStateRef(false);
  const [
    allfactualQtnsDisplayed,
    setAllfactualQtnsDisplayed,
    allfactualQtnsDisplayedRef,
  ] = useStateRef(false);

  const [
    randomPickedQuestions,
    setRandomPickedQuestions,
    randomPickedQuestionsRef,
  ] = useStateRef([]);

  const [taskFailed, setTaskFailed, taskFailedRef] = useStateRef(false);
  useEffect(() => {
    if (isFactual) {
      getInitialStartTime(0);
      getInitialEndTime(0);
    }
  }, [isFactual]);

  const [
    questionNumberAtIndex,
    setQuestionNumberAtIndex,
    questionNumberAtIndexRef,
  ] = useStateRef(0);
  const [openNotes, setOpenNotes, openNotesRef] = useStateRef(false);
  const [notesData, setNotesData, notesDataRef] = useStateRef("");
  const [notesId, setNotesId, notesIdRef] = useStateRef("");
  const [isMenuOpen, setIsMenuOpen, isMenuOpenRef] = useStateRef(false);
  const [factualAnswersList, setFactualAnswersList, factualAnswersListRef] =
    useStateRef([]);

  const navigate = useNavigate();

  function timeToSeconds(timeString) {
    let inputTime = "";
    if (timeString.split(":").length === 3) {
      inputTime = timeString;
    } else if (timeString.split(":").length === 2) {
      inputTime = "00:" + timeString;
    }
    const [hoursStr, minutesStr, secondsStr] = inputTime.split(":");
    const hours = hoursStr ? parseInt(hoursStr) : 0;
    const minutes = minutesStr ? parseInt(minutesStr) : 0;
    const seconds = secondsStr ? parseInt(secondsStr) : 0;

    return hours * 3600 + minutes * 60 + seconds;
  }

  const getInitialStartTime = async (index) => {
    try {
      var i = index;
      var startTimeData = 0;
      if (!isEmptyArray(learningStepData?.factual_rule_set)) {
        if (i < learningStepData?.factual_rule_set?.length) {
          if (
            learningStepData?.factual_rule_set?.[i]?.eval_state === undefined ||
            learningStepData?.factual_rule_set?.[i]?.eval_state !== "advanced"
          ) {
            startTimeData = learningStepData?.factual_rule_set?.[i]?.start_time
              ? timeToSeconds(
                  learningStepData?.factual_rule_set?.[i]?.start_time
                )
              : learningStepData?.content?.[0]?.content?.[0]?.startTime
              ? timeToSeconds(
                  learningStepData?.content?.[0]?.content?.[0]?.startTime
                )
              : 0;
            setStartTime(startTimeData);
          } else {
            i++;
            setQuestionIndex(i);
            getInitialStartTime(i);
          }
        } else {
          playNextContent();
        }
      } else {
        startTimeData =
          !isEmptyArray(learningStepData?.content) &&
          !isEmptyArray(learningStepData?.content?.[0]?.content)
            ? timeToSeconds(
                learningStepData?.content?.[0]?.content?.[0]?.startTime
              )
            : 0;
        setStartTime(startTimeData);
      }
    } catch (e) {}
  };

  const getInitialEndTime = async (index) => {
    try {
      let i = index;
      let endTimeData = 0;
      if (!isEmptyArray(learningStepData?.factual_rule_set)) {
        if (
          learningStepData?.factual_rule_set?.[i]?.eval_state === undefined ||
          learningStepData?.factual_rule_set?.[i]?.eval_state !== "advanced"
        ) {
          endTimeData = learningStepData?.factual_rule_set?.[i]?.end_time
            ? timeToSeconds(learningStepData?.factual_rule_set[i].end_time)
            : learningStepData?.factual_rule_set?.[i]?.popup_time
            ? timeToSeconds(learningStepData?.factual_rule_set[i].popup_time)
            : 0;
          setEndTime(endTimeData);
        } else {
          i++;
          getInitialEndTime(i);
        }
      } else {
        endTimeData =
          !isEmptyArray(learningStepData?.content) &&
          !isEmptyArray(learningStepData?.content?.[0]?.content)
            ? timeToSeconds(
                learningStepData?.content?.[0]?.content?.[0]?.endTime
              )
            : 0;
        setEndTime(endTimeData);
      }
    } catch (e) {}
  };

  const getRandomIndex = () => {
    let max_questions_length = 0;

    max_questions_length =
      learningStepData?.factual_rule_set?.[questionIndexRef.current]
        ?.max_questions;

    if (
      max_questions_length <=
      learningStepData?.factual_rule_set?.[questionIndexRef.current]?.questions
        ?.length
    ) {
      while (randomIndexsListRef.current.length < max_questions_length) {
        let randomIndex = Math.floor(
          Math.random() *
            learningStepData?.factual_rule_set?.[questionIndexRef.current]
              ?.questions?.length
        );
        if (!randomIndexsListRef.current.includes(randomIndex)) {
          setRandomIndexsList([...randomIndexsListRef.current, randomIndex]);
        }
      }
    } else {
      let randomList = [];
      for (
        let i = 0;
        i <
        learningStepData?.factual_rule_set?.[questionIndexRef.current]
          ?.questions?.length;
        i++
      ) {
        randomList.push(i);
      }
      setRandomIndexsList(randomList);
    }

    return randomIndexsListRef.current;
  };

  const getEventsStartTime = () => {
    if (questionIndexRef.current < learningStepData?.factual_rule_set?.length) {
      setStartTime(
        timeToSeconds(
          learningStepData?.factual_rule_set?.[questionIndexRef.current]
            ?.start_time
        )
      );
    } else {
      learningStepData?.content?.[0].content?.[0]?.startTime
        ? setStartTime(
            timeToSeconds(learningStepData?.content[0].content[0].startTime)
          )
        : setStartTime(0);
    }

    return startTimeRef.current;
  };

  const getEventEndTime = () => {
    if (questionIndexRef.current < learningStepData?.factual_rule_set?.length) {
      setEndTime(
        timeToSeconds(
          learningStepData?.factual_rule_set?.[questionIndexRef.current]
            ?.end_time
        )
      );
    } else {
      learningStepData?.factual_rule_set
        ? setEndTime(startTimeRef.current)
        : setEndTime(0);
    }

    return endTimeRef.current;
  };

  const handleShowBottomSheet = (isNextQuestion) => {
    if (isNotUndefinedOrNull(overAllQuestionResult)) {
      setFactualAnswersList((prevList) => [...prevList, overAllQuestionResult]);
    }
    if (overAllQuestionResult?.overAllResult) {
      setCorrectAnswersCount(correctAnswersCountRef.current + 1);
    }
    if (isNextQuestion) {
      let eval_state_at_single_popup_time =
        correctAnswersCountRef.current >=
        learningStepData?.factual_rule_set?.[questionIndexRef.current]
          ?.min_correct_answer;
      if (
        questionNumberAtIndexRef.current ===
          randomPickedQuestionsRef.current.length - 1 ||
        eval_state_at_single_popup_time === true
      ) {
        setAllfactualQtnsDisplayed(true);
        let factData = {
          eval_state: eval_state_at_single_popup_time ? "advanced" : "parked",
          step_id: learningStepData?.step_id,
          question_asked_time: endTimeRef.current,
          segment: 1,
          questions: encodeURIComponent(
            JSON.stringify(factualAnswersListRef.current)
          ), // has to construct answer array
        };
        postFactualProgress(
          factData,
          learningStepData?.lp_id,
          learningStepData?.basket,
          journeyId
        );
        setIsFactual(false);
        setHideFactual(true);
        clearScreen();
        createLearningStepCall(journeyId, true);
      } else {
        if (
          questionNumberAtIndexRef.current + 1 <=
          randomIndexsListRef.current.length
        ) {
          setRandomIndexsList(questionNumberAtIndexRef.current + 1);
        }
      }
    }

    if (
      learningStepData?.factual_rule_set?.[questionIndexRef.current]?.questions
        ?.length > 0
    ) {
      if (!isNextQuestion) {
        setDisplayedQues([]);
        let randomPickedQuestionArray = [];
        setAllfactualQtnsDisplayed(false);
        setQuestionNumberAtIndex(0);
        for (let i = 0; i < randomIndexsListRef.current.length; i++) {
          randomPickedQuestionArray.push(
            learningStepData?.factual_rule_set?.[questionIndexRef.current]
              ?.questions?.[randomIndexsListRef.current?.[i]]
          );
        }

        setRandomPickedQuestions(randomPickedQuestionArray);
      }

      if (
        isNotUndefinedOrNull(
          learningStepData?.factual_rule_set?.[questionIndexRef.current]
            ?.eval_state
        ) &&
        learningStepData?.factual_rule_set?.[questionIndexRef.current]
          ?.eval_state === "advanced"
      ) {
        // learningStepData?.factual_rule_set?.length - 1 >
        //   questionIndexRef.current &&
        //   setQuestionIndex(questionIndexRef.current + 1);
        // getEventsStartTime();
        // getEventEndTime();
        // setRefreshKey(refreshKeyRef.current + 1);
        setAllfactualQtnsDisplayed(true);
        let factData = {
          eval_state: "advanced",
          step_id: learningStepData?.step_id,
          question_asked_time: endTimeRef.current,
          segment: 1,
          questions: encodeURIComponent(
            JSON.stringify(factualAnswersListRef.current)
          ), // has to construct answer array
        };
        postFactualProgress(
          factData,
          learningStepData?.lp_id,
          learningStepData?.basket,
          journeyId
        );
        setIsFactual(false);
        setHideFactual(true);
        clearScreen();
        createLearningStepCall(journeyId, true);
      } else {
        if (isNextQuestion) {
          setQuestionNumberAtIndex(questionNumberAtIndexRef.current + 1);
        } else {
          setQuestionNumberAtIndex(questionNumberAtIndexRef.current);
        }

        if (!allfactualQtnsDisplayedRef.current) {
          setDisplayedQues((prevArray) => {
            const updatedArray = [
              ...prevArray,
              {
                ...randomPickedQuestionsRef.current[
                  questionNumberAtIndexRef.current
                ],
                isFactual: true, // or whatever value you want to assign
              },
            ];
            console.log(updatedArray); // Output the updated array to the console
            return updatedArray; // Return the updated array to the state setter function
          });
        } else {
          playNextContent();
        }
      }
    } else {
      setQuestionIndex(questionIndexRef.current + 1);
      getRandomIndex();
      getEventsStartTime();
      getEventEndTime();
      setAssessRefreshKey(assessRefreshKeyRef.current + 1);
      setRefreshKey(refreshKeyRef.current + 1);
    }
    setDisplayQuestions(false);
    setHideFactual(true);
    setDisplayQuestions(true);
    // }

    //props.handleButtonClick();
  };

  const clearScreen = () => {
    setDisplayedQues([]);
    setCurrentQuestionIndex(0);
    setChatHistory([]);
    setChatQuery("");
  };

  useEffect(() => {
    setRefreshKey(refreshKey + 1);
  }, [endTime, isFactual]);

  useEffect(() => {
    setContent(learningStepData?.contents);
    setCurrentContentIndex(currentIndexRef.current);
    if (learningStepData?.factual_rule_set?.length > 0) {
      getRandomIndex();
    }
  }, [questionIndexRef.current, isFactual]);

  const setCurrentContentIndex = (index) => {
    if (contentRef.current?.length > index) {
      setCurrentContent(contentRef.current?.[index]);
      setCurrentIndex(index);
    }
  };
  const playNextContent = () => {
    let nextIndex = currentIndexRef.current + 1;
    if (contentRef.current?.length > nextIndex) {
      setCurrentContentIndex(nextIndex);
      setQuestionIndex(0);
    } else {
      //props.handleButtonClick();
    }
  };

  useEffect(() => {
    if (isHome && onNextItemSelected) {
      {
        taskStepId && setLearnStepId(taskStepId);
      }
      if (isNotEmptyOrNull(journeyId) && !isReviewScreen) {
        createLearningStepCall(journeyId);
      }
    } else if (isLearn && onNextItemSelected && !isReviewScreen) {
      if (isNotEmptyOrNull(journeyId)) {
        createLearningStepCall(journeyId);
      } else if (isNotEmptyOrNull(selectedExperiential)) {
        createSelfLearn(
          isChapterEndAssessment,
          chapterEndAssessmentType,
          selectedExperiential
        );
      } else {
        if (isNotEmptyOrNull(taskId)) {
          callStartTask(taskId);
        } else {
          createSelfLearn(isChapterEndAssessment, chapterEndAssessmentType, {});
        }
      }
    } else if (isExperientialFromWall) {
      createSelfLearn(
        isChapterEndAssessment,
        chapterEndAssessmentType,
        selectedExperiential
      );
      setIsExperientialFromWall(false);
    }
  }, [
    topic,
    journeyId,
    taskId,
    subTopicId,
    onNextItemSelected,
    callSameSubTopicAgain,
    isExperientialFromWall,
  ]);

  const createSelfLearn = async (
    isChapterEndAssessment,
    chapterEndAssessmentType,
    experiential
  ) => {
    let bodyData = {
      taskType: isExperientialFromWall ? "experientialLearning" : taskType,
      subjectId: isExperientialFromWall
        ? experiential.subjectId
        : subjectMasterUUid,
      topicId: isExperientialFromWall ? experiential.topicId : topicId,
      taskAttributes: {
        subtopicId: isExperientialFromWall
          ? experiential.subtopicId
          : subTopicId,
        topicMasterUuid: isExperientialFromWall
          ? experiential.topicMasterUuid
          : topicMasterUuid,
        topicName: isExperientialFromWall ? experiential.topicName : topic,
        subtopicName: isExperientialFromWall
          ? experiential.subTopicName
          : subTopic,
        chapterEndAssessment: isChapterEndAssessment,
        proficiencyLevel: chapterEndAssessmentType.toLowerCase(),
        experientialLearning: {
          id: experiential?.id,
          title: experiential?.title,
          allowCommentsAndInteractions:
            experiential?.allowCommentsAndInteractions,
        },
      },
    };
    try {
      const { success, data } = await callSelfLearn(bodyData);
      console.log(data);
      if (success) {
        setOnNextItemSelected(false);
        setTaskId(data?.data?._id);
        callStartTask(data?.data?._id);
      } else {
        console.log("Failure");
      }
    } catch (error) {}
  };

  const callStartTask = async (id) => {
    setTaskFailed(false);
    // setTaskId(id);
    try {
      const { success, data } = await startTask(id);
      if (success) {
        if (
          isNotEmptyOrNull(data?.data?.taskAttributes?.experientialLearning)
        ) {
          setDisplayExperiential(true);
          setExperientialLearningData(
            data?.data?.taskAttributes?.experientialLearning
          );
          navigate(`${urlString}/experiential`, {
            state: {
              experientialLearningData:
                data?.data?.taskAttributes?.experientialLearning,
            },
          });
        } else {
          setOnNextItemSelected(false);
          setJourneyId(data?.data?.journeyId);
          setTaskStepId(data?.data?.stepId);
          createLearningStepCall(data?.data?.journeyId);
        }

        console.log(data);
      } else {
        setTaskFailed(true);
        console.log("Failure");
      }
    } catch (error) {}
  };

  const createLearningStepCall = (
    id,
    factual,
    resultObject,
    chatId,
    answerValue
  ) => {
    setTaskFailed(false);
    let answerObject = {};
    if (!isEmptyObject(resultObject)) {
      answerObject = {
        ...resultObject,
        chatId: chatId,
      };
    }
    checkRules(id, factual, answerObject, answerValue);
  };

  const checkRules = (id, factual, answer, answerValue) => {
    let isStepExit = false;

    learningStepData?.rules?.forEach((result) => {
      if (
        result?.condition?.toLowerCase() === "greaterthanequal" &&
        answerCount >= Number(result?.value)
      ) {
        isStepExit = result.stepExit;
        return;
      } else if (
        result?.condition?.toLowerCase() === "lessthanequal" &&
        answerCount <= Number(result?.value)
      ) {
        isStepExit = result?.stepExit;
        return;
      } else if (
        result?.condition?.toLowerCase() === "equal" &&
        answerCount === Number(result?.value)
      ) {
        isStepExit = result?.stepExit;
        return;
      }
    });

    if (isStepExit) {
      clearScreen();
    }
    callGetLearningSteps(
      id,
      learningStepData?.step_id ? learningStepData?.step_id : 1,
      factual ? "" : answer,
      factual ? 1 : answerValue
    );
  };

  const callFinishStep = async () => {
    try {
      const { success, data } = await endTask(taskId, "");
      console.log(data);
      if (!isEmptyObject(data)) {
        if (data?.taskStatus === "completed") {
          setTaskStatus(
            isNotUndefinedOrNull(data?.message)
              ? data.message
              : "Looks like " +
                  (subTopicName ? subTopicName : topicName) +
                  " clicked!  Ready for the next challenge?"
          );
          setIsTaskCompleted(true);
        }
        if (isNotEmptyOrNull(data?.analytics)) {
          setTaskAnalytics(data?.analytics);
        }
      }
    } catch (error) {}
  };

  const callGetLearningSteps = async (
    journey_id,
    step_id,
    user_answer,
    count
  ) => {
    setRandomIndexsList([]);
    try {
      const { success, data } = await learnApiService(
        journey_id,
        step_id,
        user_answer,
        count
      );
      if (success) {
        if (data.step_id == "0") {
          callFinishStep();
        } else {
          if (
            data?.learning_mode !== undefined &&
            data?.learning_mode.toLowerCase() === learningModes.FactualBasket
          ) {
            setIsFactual(true);
            setHideFactual(false);
          } else {
            setIsFactual(false);
            setHideFactual(true);
          }
          setLearningStepData(data);
          if (
            !isNotEmptyOrNull(data?.questions) ||
            data?.questions.length === 0
          ) {
            setQuestionNotAvailable(true);
          }
          let questionObj = data.questions[0];
          questionObj.tutor_solution_steps = [];
          setOnNextItemSelected(false);
          setLearningStepData(data);
          setLearnStepId(data.step_id);
          setDisplayedQues((prevArray) => [...prevArray, questionObj]);
          console.log("raghavendra", questionsRef.current);
          setLearningStepsData(JSON.stringify(data));
        }
      } else {
        console.log("Failure");
      }
    } catch (error) {}
  };

  const handleNextQuestion = (resultObject, chatId, answerValue) => {
    handleUpdateisConv();
    if (isFactual) {
      handleShowBottomSheet(true);
    } else {
      createLearningStepCall(
        journeyId,
        false,
        resultObject,
        chatId,
        answerValue
      );
    }
  };

  const handleUpdateisConv = () => {
    let index = currentQuesIndex;
    let existing = [...displayedQues];
    if (taskType !== "assessment" && !isFactual) {
      existing[index].showGreen = true;
      existing[index].showRed = true;
    }
    setDisplayedQues(existing);
  };

  const handleSaveChatConv = async (
    query,
    chatId,
    displayedQues,
    currentQuesIndex
  ) => {
    let inputBody = {
      grade: grade,
      subject: subject,
      topic_name: topic,
      user_query: query,
      chat_uuid: chatId,
      chat_index: 0,
      question: displayedQues[currentQuesIndex],
    };
    // setLoader(true);
    const response = await saveChatConv(inputBody);
    if (isEmptyOrNull(response)) {
      showToast({
        description: "Something went wrong",
        status: "error",
      });
    }
  };

  const state = {
    handleNextQuestion,
    handleSaveChatConv,
    currentContent: currentContentRef.current,
    setCurrentContent,
    handleShowBottomSheet,
    startTime: startTimeRef.current,
    setStartTime,
    endTime: endTimeRef.current,
    setEndTime,
    setDisplayQuestions,
    displayQuestions: displayQuestionsRef.current,
    hideFactual: hideFactualRef.current,
    setHideFactual,
    questionNotAvailable: questionNotAvailableRef.current,
    taskFailed: taskFailedRef.current,
  };
  return (
    <LearnContext.Provider value={state}>{children}</LearnContext.Provider>
  );
};

export const useLearn = () => {
  return useContext(LearnContext);
};
